<script setup>
// BonBoZ: gán MỘT LOẠT mẫu đã tick cho một hay nhiều trang.
//
// Chiều ngược với `CannedByPage.vue` (một trang → nhiều mẫu). Ở đây gán theo
// kiểu THÊM VÀO, không gỡ mẫu cũ của trang — xem `ganMauTrang.js`. Vì không gỡ
// gì nên hộp này không cần hiện trang đang có mẫu nào.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { loadPageConfigs } from 'dashboard/helper/pageConfig';
import { ganMauChoTrang } from 'dashboard/helper/bonboz/ganMauTrang';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  mauIds: { type: Array, required: true },
});
const emit = defineEmits(['close', 'xong']);

const { t } = useI18n();
const store = useStore();
const inboxes = useMapGetter('inboxes/getInboxes');

const chon = ref([]);
const dangLuu = ref(false);

// Cần cấu hình MỚI NHẤT: gán là hợp vào danh sách hiện có của từng trang, đọc
// bản cũ trong bộ nhớ thì có thể ghi đè mất mẫu người khác vừa gán.
loadPageConfigs(true);
if (!inboxes.value.length) store.dispatch('inboxes/get');

const doi = id => {
  const i = chon.value.indexOf(id);
  if (i === -1) chon.value.push(id);
  else chon.value.splice(i, 1);
};

const luu = async () => {
  if (!chon.value.length || dangLuu.value) return;
  dangLuu.value = true;
  const { xong, loi } = await ganMauChoTrang(chon.value, props.mauIds);
  dangLuu.value = false;
  if (loi) {
    useAlert(loi);
    return;
  }
  useAlert(
    t('BONBOZ.GAN_NHIEU.DA_GAN', { mau: props.mauIds.length, trang: xong })
  );
  emit('xong');
};
</script>

<template>
  <woot-modal show :on-close="() => emit('close')">
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header
        :header-title="$t('BONBOZ.GAN_NHIEU.TIEU_DE')"
        :header-content="
          $t('BONBOZ.GAN_NHIEU.MO_TA', { so: props.mauIds.length })
        "
      />
      <div class="flex flex-col gap-3 p-8 pt-4">
        <div class="flex flex-col gap-1 max-h-[50vh] overflow-y-auto">
          <label
            v-for="ib in inboxes"
            :key="ib.id"
            class="flex items-center gap-2 px-2 py-1.5 text-sm rounded-md cursor-pointer text-n-slate-12 hover:bg-n-alpha-1"
          >
            <input
              type="checkbox"
              class="shrink-0"
              :checked="chon.includes(ib.id)"
              @change="doi(ib.id)"
            />
            <span class="truncate">{{ ib.name }}</span>
          </label>
        </div>
        <p class="m-0 text-xs text-n-slate-11">
          {{ $t('BONBOZ.GAN_NHIEU.GHI_CHU') }}
        </p>
        <div class="flex justify-end gap-2">
          <NextButton
            faded
            slate
            sm
            :label="$t('CANNED_MGMT.ADD.CANCEL_BUTTON_TEXT')"
            @click="emit('close')"
          />
          <NextButton
            sm
            :label="$t('BONBOZ.GAN_NHIEU.LUU', { so: chon.length })"
            :disabled="!chon.length || dangLuu"
            :is-loading="dangLuu"
            @click="luu"
          />
        </div>
      </div>
    </div>
  </woot-modal>
</template>
